import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=386a1a4f&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a1a4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386a1a4f')) {
      api.createRecord('386a1a4f', component.options)
    } else {
      api.reload('386a1a4f', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=386a1a4f&scoped=true&", function () {
      api.rerender('386a1a4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/mine_nav/widget.vue"
export default component.exports